module.exports = __webpack_public_path__ + "static/media/ic_club.81f1c3a1.svg";